export const UPDATE_CLIENT_LIST = 'UPDATE_CLIENT_LIST';


export const updateClientList = (clients) => ({
  type: UPDATE_CLIENT_LIST,
  payload: { clients }
});
